module.exports = __webpack_public_path__ + "img/list1.8cae81cc.png";